import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { MultiSelect } from "../../components/formValidation/MultiSelect";
import { TextField } from "../../components/formValidation/TextField";
import { Toggle } from "../../components/formValidation/Toggle";
import { setParems } from "../../redux/Campaign";
import api from "../../utils/api";
import DaynmicApicall from "../../utils/function";

export default function AddMenu(props) {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state?.user?.value);
  const [scripttype, setScriptType] = useState([]);
  const [eligible, setEligible] = useState([]);
  const [colorcode, setColorcode] = useState([]);
  const [pageData, setpageData] = useState({});
  const [responsemaster, setResponsemaster] = useState([]);

  async function getEligible() {
    api
      .get(
        `prm/getParamdata/ALL/ELIGIBLE_FOR/${props.data.activeMenu.keypointer}`,
        {
          headers: {
            Authorization: userInfo.data[0].UserToken, //the token is a variable which holds the token
          },
        }
      )
      .then(async (res) => {
        let bData = [];
        bData = await res.data.data.map((item) => {
          return {
            value: item.paracode,
            label: item.paravalue,
          };
        });
        setEligible(bData);
      })
      .catch((error) => {
        toast.error(
          error.response.data.message ??
            error.message ??
            "OOPs, something went wrong."
        );
      });
  }

  async function getResponsemasterlist() {
    api
      .get(`appuser/getrespmaster/${props.data.activeMenu.keypointer}`, {
        headers: {
          Authorization: userInfo.data[0].UserToken, //the token is a variable which holds the token
        },
      })
      .then(async (res) => {
        let bData = [];
        bData = await res.data.data.map((item) => {
          return {
            value: item.resp_code,
            label: item.resp_desc,
          };
        });
        bData.push({ value: "NA", label: "NA" });
        setResponsemaster(bData);
      })
      .catch((error) => {
        toast.error(
          error.response.data.message ??
            error.message ??
            "OOPs, something went wrong."
        );
      });
  }

  async function getScriptType() {
    await DaynmicApicall(
      `prm/getParamdata/ALL/SCRIPT-TYPE/${props.data.activeMenu.keypointer}`,
      "",
      "get",
      userInfo.data[0].UserToken
    )
      .then(async (res) => {
        let bData = [];
        bData = await res.map((item) => {
          return {
            value: item.paravalue,
            label: item.paracode,
          };
        });

        setScriptType(bData);
      })
      .catch((error) => {
        toast.error(
          error.response.message ??
            error.message ??
            "OOPs, something went wrong."
        );
      });
  }

  async function getColorcode() {
    api
      .get(
        `prm/getParamdata/ALL/COLOR_CODE_RESP/${props.data.activeMenu.keypointer}`,
        {
          headers: {
            Authorization: userInfo.data[0].UserToken, //the token is a variable which holds the token
          },
        }
      )
      .then(async (res) => {
        let bData = [];
        bData = await res.data.data.map((item) => {
          return {
            value: item.paracode,
            label: item.paravalue,
          };
        });
        setColorcode(bData);
      })
      .catch((error) => {
        toast.error(
          error.response.data.message ??
            error.message ??
            "OOPs, something went wrong."
        );
      });
  }

  async function pageInfo() {
    await DaynmicApicall(
      `/appuser/getcomponetbyid/${props.data.activeMenu.keypointer}/${props.data.activeMenu.subcompid}`,
      "",
      "get",
      userInfo.data[0].UserToken
    ).then((data) => {
      setpageData(data[0].DATA);
    });
  }
  useEffect(async () => {
    await getResponsemasterlist();
    await getScriptType();
    getEligible();
    getColorcode();
    await pageInfo();
  }, []);
  let action = props?.data?.paremsData.action === "UPDATE";
  let initial = {
    respscore: action ? props?.data?.paremsData.comp.resp_score : "",
    respcolorcode: action
      ? colorcode.find(
          (v) => v.value == props?.data?.paremsData.comp?.resp_color
        )
      : "",
    respcode: action ? props?.data?.paremsData.comp.resp_code : "",
    respname: action ? props?.data?.paremsData.comp.resp_desc : "",
    usereligible: action
      ? eligible?.filter((v) =>
          props?.data?.paremsData.comp.user_eligible.split(",")
        )
      : "",
    removestatus: action ? props?.data?.paremsData.comp.remove_status : "",
    leadstatus: action ? props?.data?.paremsData.comp.lead_status : "",
    responselevel: action ? props?.data?.paremsData.comp.resp_level : "",
    agentstatus: action ? props?.data?.paremsData.comp.agent_status : "",
    createdby: userInfo.data[0].userid,
    keypointer: props.data.activeMenu.keypointer,
    client_respcode: action
      ? props?.data?.paremsData.comp.client_resp_code
      : "",
    resp_type: action
      ? scripttype.find(
          (v) => v.value === props?.data?.paremsData.comp.resp_type
        )
      : "",
    parent_respcode: action
      ? responsemaster.find(
          (v) => v.value === props?.data?.paremsData.comp?.parent_resp_code
        )
      : "",
    action_name: action ? "UPDATE" : "INSERT",
    active: action
      ? props?.data?.paremsData.comp.is_active === "Y"
        ? true
        : false
      : true,
    tooltips: action ? props?.data?.paremsData.comp.tooltips : "",
  };
  const validate = Yup.object({
    respcode: Yup.string().required("Response Code is required"),
    respname: Yup.string().required("Response Name is required"),
    usereligible: Yup.array().of(
      Yup.object().required("Eligible For is required")
    ),
    resp_type: Yup.object().required("Response Type is required"),
    parent_respcode: Yup.object().required("Parent Response Code is required"),
    respcolorcode: Yup.object().required("Response Color Code is required"),
    respscore: Yup.number()
      .required("Score is required")
      .min(0, "Score must be non-negative")
      .max(100, "Score must be up to 100"),
    client_respcode: Yup.string().required("Client Response Code is required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    values.active = values.active === true ? "Y" : "N";
    values.removestatus = values.removestatus === true ? 1 : 0;
    values.agentstatus = values.agentstatus === true ? 1 : 0;
    values.leadstatus = values.leadstatus === true ? 1 : 0;
    values.responselevel = values.responselevel === true ? 1 : 0;
    values.resp_type = values.resp_type.value;
    values.parent_respcode = values.parent_respcode.value;
    values.respcolorcode = values.respcolorcode.value;
    // values.keypointer = props.data.activeMenu.keypointer
    let uRigt = values.usereligible.map((v) => v.value);
    values.usereligible = uRigt.toString();
    if (props.data.paremsData.action === "INSERT") {
      const Info = await DaynmicApicall(
        `appuser/respcodemaster/`,
        values,
        "post",
        userInfo.data[0].UserToken
      );
      toast.success(Info.message);
      dispatch(setParems({ data: "" }));
    } else {
      const Info = await DaynmicApicall(
        `appuser/respcodemaster/`,
        values,
        "post",
        userInfo.data[0].UserToken
      );
      toast.success(Info.message);
      dispatch(setParems({ data: "" }));
    }
  };

  return (
    <>
      {Object.keys(pageData).length > 0 ? (
        <Formik
          initialValues={initial}
          validationSchema={validate}
          onSubmit={onSubmit}
        >
          {(formik) => (
            <div
              className="card card-body border-light shadow mb-4"
              style={pageData?.style}
            >
              <h6 className="text-light card-header rounded bg-dark">
                {" "}
                {props?.data?.paremsData?.action === "INSERT"
                  ? pageData.fieldsData?.titleAdd
                  : pageData.fieldsData?.titleUpdate}
              </h6>
              <Form>
                <div className="row mt-3">
                  <TextField
                    data-toggle="tooltip"
                    title="Please Enter Response Code"
                    label={pageData.fieldsData.ResponseCode.label}
                    name={pageData.fieldsData.ResponseCode.name}
                    placeholder={pageData.fieldsData.ResponseCode.placeholder}
                    type={pageData.fieldsData.ResponseCode.type}
                    // defaultValue={props.data.ResponseCode.action === "UPDATE" ? userData?.ResponseCode : null}
                    disabled={props?.data?.paremsData.action === "UPDATE"}
                  />
                  <TextField
                    data-toggle="tooltip"
                    title="Please Enter Response Name"
                    label={pageData.fieldsData.ResponseName.label}
                    name={pageData.fieldsData.ResponseName.name}
                    placeholder={pageData.fieldsData.ResponseName.placeholder}
                    type={pageData.fieldsData.ResponseName.type}
                  />
                  <MultiSelect
                    label={pageData.fieldsData.Eligible.label}
                    name="usereligible"
                    placeholder="Select Eligible for"
                    type="select"
                    value={formik.values.usereligible}
                    isMulti={true}
                    options={eligible}
                    onChange={(value) =>
                      formik.setFieldValue("usereligible", value)
                    }
                  />
                  <MultiSelect
                    label={pageData?.resptype?.label}
                    name={pageData?.resptype?.name}
                    placeholder={pageData?.resptype?.placeholder}
                    type={pageData?.resptype?.type}
                    value={formik.values.resp_type}
                    isMulti={false}
                    options={scripttype}
                    onChange={(value) =>
                      formik.setFieldValue("resp_type", value)
                    }
                  />
                  <MultiSelect
                    label={pageData?.parentRespcode?.label}
                    name={pageData?.parentRespcode?.name}
                    placeholder={pageData?.parentRespcode?.placeholder}
                    type="multi"
                    value={formik.values.parent_respcode}
                    isMulti={false}
                    options={responsemaster}
                    onChange={(value) =>
                      formik.setFieldValue("parent_respcode", value)
                    }
                  />
                  <MultiSelect
                    label={pageData?.respColorcode?.label}
                    name="respcolorcode"
                    placeholder="Select Color Code"
                    type="select"
                    value={formik.values.respcolorcode}
                    isMulti={false}
                    options={colorcode}
                    onChange={(value) =>
                      formik.setFieldValue("respcolorcode", value)
                    }
                  />
                  <TextField
                    data-toggle="tooltip"
                    title="Please Enter Score"
                    label={pageData?.score?.label}
                    name={pageData?.score?.name}
                    placeholder={pageData?.score?.placeholder}
                    type={pageData?.score?.type}
                  />
                  <TextField
                    data-toggle="tooltip"
                    title="Please Enter Client Response Code"
                    label={pageData?.clientRespcode?.label}
                    name={pageData?.clientRespcode?.name}
                    placeholder={pageData?.clientRespcode?.placeholder}
                    type={pageData?.clientRespcode?.type}
                  />
                  <TextField
                    data-toggle="tooltip"
                    title="Please Enter Tooltip"
                    label={pageData?.tooltips?.label}
                    name={pageData?.tooltips?.name}
                    placeholder={pageData?.tooltips?.placeholder}
                    type={pageData?.tooltips?.type}
                  />
                  <div className="row mt-4">
                    <Toggle
                      data-toggle="tooltip"
                      title="Remove Status"
                      defaultChecked={formik.values.removestatus}
                      value={formik.values.removestatus}
                      onChange={(e) =>
                        formik.setFieldValue("removestatus", e.target.checked)
                      }
                      label={pageData?.fieldsData?.RemoveStatus?.label}
                      name={pageData?.fieldsData?.RemoveStatus?.name}
                      placeholder={
                        pageData?.fieldsData?.RemoveStatus?.placeholder
                      }
                    />
                    <Toggle
                      data-toggle="tooltip"
                      title="Lead Status"
                      label={pageData?.fieldsData?.LeadStatus?.label}
                      name={pageData?.fieldsData?.LeadStatus?.name}
                      placeholder={
                        pageData?.fieldsData?.LeadStatus?.placeholder
                      }
                      type={pageData?.fieldsData?.LeadStatus?.type}
                      defaultChecked={formik.values.leadstatus}
                      value={formik.values.leadstatus}
                      onChange={(e) =>
                        formik.setFieldValue("leadstatus", e.target.checked)
                      }
                    />
                    <Toggle
                      data-toggle="tooltip"
                      title="Response Level"
                      label={pageData?.fieldsData?.ResLevel?.label}
                      name={pageData?.fieldsData?.ResLevel?.name}
                      type={pageData?.fieldsData?.ResLevel?.type}
                      defaultChecked={formik.values.responselevel}
                      value={formik.values.responselevel}
                      onChange={(e) =>
                        formik.setFieldValue("responselevel", e.target.checked)
                      }
                    />
                    <Toggle
                      data-toggle="tooltip"
                      title="Agent Status"
                      label={pageData?.fieldsData?.AgentStatus?.label}
                      name={pageData?.fieldsData?.AgentStatus?.name}
                      type={pageData?.fieldsData?.AgentStatus?.type}
                      defaultChecked={formik.values.agentstatus}
                      value={formik.values.agentstatus}
                      onChange={(e) =>
                        formik.setFieldValue("agentstatus", e.target.checked)
                      }
                    />
                    <Toggle
                      data-toggle="tooltip"
                      title="Response Code Active and de-active"
                      label={pageData?.fieldsData?.status?.label}
                      name={pageData?.fieldsData?.status?.name}
                      type={pageData?.fieldsData?.status?.type}
                      defaultChecked={formik.values.active}
                      value={formik.values.active}
                      onChange={(e) =>
                        formik.setFieldValue("active", e.target.checked)
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-1">
                  <button
                    type={pageData?.fieldsData?.button.type}
                    className="btn btn-primary btn-sm m-2"
                    style={pageData?.fieldsData?.button.style}
                  >
                    {pageData?.fieldsData?.button.label}
                  </button>
                  <Link
                    to="MNU_MANAGE_RESPONSE"
                    className="btn btn-primary btn-sm m-2 text-white"
                    style={pageData.fieldsData.cancelButton.style}
                    onClick={(e) => {
                      dispatch(setParems({ data: "MNU_MANAGE_RESPONSE" }));
                    }}
                  >
                    {pageData.fieldsData.cancelButton.label}
                  </Link>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      ) : (
        ""
      )}
    </>
  );
}
